import React from 'react';
import { Spinner } from '@smarterservices/smarter-ui';

/**
 * Loading component for elements
 * Displays a centered spinner while the element is loading
 */
function ElementLoader() {
  return (
    <div 
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        padding: '2rem'
      }}
    >
      <Spinner size="large" renderTitle="Loading element..." />
    </div>
  );
}

export default ElementLoader;
